<template>
  <div class="ibox">
    <div class="ibox-title"><h5>用户黑名单</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-input v-model="keyword" placeholder="昵称 / 手机号" style="width:260px" @keyup.enter.native="search">
        <el-button slot="append" icon="el-icon-search" @click="search" />
      </el-input>
    </div>
    <el-table :data="pagedList" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="nickName" label="昵称" />
      <el-table-column prop="tel" label="手机号" width="140" />
      <el-table-column label="VIP" width="90">
        <template slot-scope="s">
          <el-tag :type="s.row.vip === '2' ? 'success' : (s.row.vip === '3' ? 'danger' : 'info')">
            {{ s.row.vip === '2' ? 'VIP' : (s.row.vip === '3' ? '禁用' : '普通') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="express_time" label="会员到期" width="170" />
      <el-table-column prop="login_time" label="最近登录" width="170" />
      <el-table-column label="操作" width="180">
        <template slot-scope="s">
          <el-button size="mini" type="danger" @click="onRemove(s.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
    </div>
  </div>
</template>

<script>
import { userBlacklistApi } from '../api/business'

export default {
  name: 'AdminUserBlacklist',
  data () {
    return {
      list: [],
      loading: false,
      keyword: '',
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    total () { return this.list.length },
    totalPages () { return Math.max(1, Math.ceil(this.total / this.pageSize)) },
    pagedList () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.list.slice(start, start + this.pageSize)
    }
  },
  watch: {
    totalPages (val) { if (this.currentPage > val) this.currentPage = val }
  },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try { this.list = await userBlacklistApi.list(this.keyword) } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    search () {
      this.currentPage = 1
      this.fetch()
    },
    handleCurrentChange (page) {
      this.currentPage = page
    },
    // 移除：将黑名单用户整行还原回 users 表（user_blacklist -> users 转移接口）
    async onRemove (row) {
      if (!await this.$confirm(`将「${row.nickName || row.id}」移出黑名单并还原到用户表？`, '提示', { type: 'warning' }).catch(() => false)) return
      try {
        await userBlacklistApi.restore(row.id)
        this.$message.success('移除成功，已还原到用户表'); this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
